import React, { PropsWithChildren } from "react";
import { useDispatch } from "react-redux";
import Modal from "react-modal";

import { showModal, hideModal } from "./lib/actions";
import modalReducer from "./lib/reducers";

interface Props {
  show: boolean;
  externalClass: string;
  externalBodyClass?: string;
}

const ReactModal: React.FC<PropsWithChildren<Props>> = ({
  children,
  show,
  externalClass = "",
  externalBodyClass = "",
}: PropsWithChildren<Props>): JSX.Element => {
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={show}
      onRequestClose={(): void => {
        dispatch(hideModal());
      }}
      overlayClassName="modal-overlay"
      className={`modal-body ${externalClass}`}
      appElement={document.querySelector("#root") as HTMLElement}
    >
      <div className="modal-wrapper">
        <div className="modal-close-btn">
          <button
            onClick={(): void => {
              dispatch(hideModal());
            }}
            className="caprx-icon-inputclose"
          />
        </div>
        <div className={`modal-body-content ${externalBodyClass}`}>{children}</div>
      </div>
    </Modal>
  );
};

export { ReactModal, showModal, modalReducer };
